import { gql, TypedDocumentNode } from '@apollo/client';

import { MyUserSecretsQuery, MyUserSecretsQueryVariables } from '../generated';

export const MY_USER_SECRETS: TypedDocumentNode<
  MyUserSecretsQuery,
  MyUserSecretsQueryVariables
> = gql`
  query MyUserSecrets {
    myUserSecrets {
      id
      key
      value
      encryptKeyHash
      description
      createdAt
      updatedAt
    }
  }
`;
